var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWindAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 121",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-997,-155)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,199.71,-1682.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "windAlt",
    transform: "matrix(1,0,0,1,-2.22322,13.6823)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.806248,0,0,0.452573,575.627,370.482)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 302.383,
    cy: 1395.21,
    r: 70.807,
    style: {
      fill: "rgb(10,81,222)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.950689,-0.0386054,0.0687746,0.533653,505.558,161.392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.686,1605.09C231.521,1607.87 228.923,1609.58 224.789,1611.39",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.953173,0.000408587,-0.000727888,0.535047,615.905,150.094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.49,1602.1C228.916,1602.74 228.148,1603.34 227.33,1603.74",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.70083,0.0143812,-0.0348212,0.53469,731.485,146.656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.48,1566.57C246.361,1574.97 247.288,1584.49 242.118,1595.25",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "4.56px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.952695,0.0169432,-0.0301839,0.534779,661.785,145.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.49,1555C233.121,1557 235.832,1559.17 238.453,1562.01",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966405,0.0159534,-0.0268805,0.513077,652.796,179.822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.373,1576.31C240.273,1582.76 239.829,1586.94 237.884,1592.82",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.951755,-0.0291706,0.0519667,0.534251,532.817,157.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.947,1560.65C232.195,1563.82 235.112,1566.74 237.478,1571.75",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.953173,0,0,0.535047,614.739,149.683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.901,1580.69C190.484,1567.73 198.385,1558.41 213.355,1557.18",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.952008,-0.0264412,0.0471042,0.534393,541.556,156.006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.14,1565.07C194.722,1555.2 202.995,1551.92 214.053,1552.13",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.951362,0.032969,-0.0587335,0.53403,707.349,145.221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.03,1582.27C182.13,1578.21 182.896,1574.33 184.43,1570.44",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.953173,0,0,0.535047,614.739,149.683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.386,1636.26L211.009,1587.93L216.457,1587.93L218.9,1636.42",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09005,0,0,0.619798,584.125,16.1149)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 214.901,
    cy: 1582.3,
    r: 3.999,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.953173,0,0,0.535047,614.739,149.683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.513,1578.1L224.365,1553.72C224.86,1550.85 220.986,1549.63 220.004,1552.64L212.153,1575.54C210.751,1581.97 217.94,1582.62 219.513,1578.1Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.332865,0.501362,-0.893163,-0.186848,2304.92,1185.01)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.513,1578.1L224.365,1553.72C224.86,1550.85 220.986,1549.63 220.004,1552.64L212.153,1575.54C210.751,1581.97 217.94,1582.62 219.513,1578.1Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.39758,-0.48628,0.866296,-0.223175,-468.144,1454.94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.513,1578.1L224.365,1553.72C224.86,1550.85 220.986,1549.63 220.004,1552.64L212.153,1575.54C210.751,1581.97 217.94,1582.62 219.513,1578.1Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.941888,0,0,0.535047,617.103,149.683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.776,1636.42L222.685,1636.42",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: "4.02px"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindAlt);
export default __webpack_public_path__ + "static/media/windAlt.6fda0e0ce9b3bd2681ad5b559cd60836.svg";
export { ForwardRef as ReactComponent };